import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { ModalContent } from "../interfaces/form-model";

@Injectable({
  providedIn: 'root'
})
export class GenericModalService {

  private modalContent$ =  new BehaviorSubject<ModalContent>(this.getDefaultModalContent());

  constructor() { }

  setRestartModal(message: string): void {
    this.modalContent$.next({
      type: "RESTART",
      preventClose: true,
      data: {
        message: message
      }
    });
  }

  setAlertModal(message: string): void {
    this.modalContent$.next({
      type: "ALERT",
      preventClose: false,
      data: {
        message: message
      }
    });
  }

  getModalContent$(): Observable<ModalContent> {
    return this.modalContent$.asObservable();
  }

  getModalContent(): ModalContent {
    return this.modalContent$.getValue();
  }

  setModalHidden(): void {
    this.modalContent$.next(this.getDefaultModalContent());
  }

  private getDefaultModalContent(): ModalContent {
    return { type: "HIDDEN" };
  }
}
